import React from 'react'
import {
    Container,
    ImageList,
    ImageListItem,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material"
import A from '../assets/image/A.jpg'
import B from '../assets/image/B.jpg'
import C from '../assets/image/C.jpg'
import D from '../assets/image/D.jpg'
import E from '../assets/image/E.jpg'
import F from '../assets/image/F.jpg'
import G from '../assets/image/G.jpg'
import H from '../assets/image/H.jpg'
import I from '../assets/image/I.jpg'





const itemData = [
    { img: A, title: '' },
    { img: H, title: '' },
    { img: I, title: '' },
    { img: B, title: '' },
    { img: E, title: '' },
    { img: F, title: '' },
    { img: G, title: '' },
    { img: D, title: '' },
    { img: C, title: '' },

];

const Gallery = () => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm')); // <600px
    const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600px - 900px

    const getCols = () => {
        if (isXs) return 1;
        if (isSm) return 2;
        return 3;
    };

    return (
        <>
            <Typography
                variant="h6"
                sx={{
                    textAlign: "center",
                    color: "#002fa7",
                    fontSize: 25,
                    mb: 3,
                    mt: 5
                }}
            >
                वस्तिगृहातील फोटो
            </Typography>
            <Container sx={{ mb: 5 }}>
                <ImageList
                    sx={{
                        width: "100%",
                    }}
                    cols={getCols()}
                    gap={12}
                >
                    {itemData.map((item) => (
                        <ImageListItem key={item.img}>
                            <img
                                srcSet={`${item.img}?w=300&h=300&fit=crop&auto=format&dpr=2 2x`}
                                src={`${item.img}?w=300&h=300&fit=crop&auto=format`}
                                alt={item.title}
                                loading="lazy"
                                style={{ borderRadius: 10 }}
                            />
                        </ImageListItem>
                    ))}
                </ImageList>
            </Container>
        </>
    );
};

export default Gallery;
